import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetTotalSaleInput } from '../domain/dtos/get-total-sale-input'
import { GetTotalSaleOutput } from '../domain/dtos/get-total-sale-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { GetOfferIds } from './get-offer-ids'

export class GetTotalSale {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetTotalSaleInput, signal?: AbortSignal): Promise<GetTotalSaleOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/receiver/summary/sales`,
      body: this.makeBody(input),
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeBody(input: GetTotalSaleInput) {
    const offerIds = new GetOfferIds().execute({ offerIds: input.offerIds, offers: input.offers })

    return {
      startDate: input.startDate,
      endDate: input.endDate,
      offerIds,
    }
  }
}
